import React, {Component} from 'react';

export default class GasView extends Component {
  render() {
    return (
      <section className="container tip-flex">
        <div className="tip-outline">
          <div className="guide-section">
            <h2>Quick Tips</h2>
            <ul>
                <li><p className="tip gas-tip">Lower Thermostat: Especially in the winter, when gas bills soar, lowering the thermostat by even a couple degrees can make a difference in your bill, helping you save as much as 5 to 10%. If lowering the heat would make your home uncomfortable in the evenings, try reducing the temperature only at night, or during the day if family members are at work. If you’re having trouble getting your gas payments to a manageable level, take a look at your thermostat settings and see what adjustments you can make.</p></li>
                <li><p className="tip gas-tip">Keep Doors and Windows Closed: Along the same lines, be sure to keep doors and windows closed when your natural gas heating system is running. Opening windows and doors can be great for cooling off a hot house on summer evenings, but in the colder seasons, it will let valuable heat escape. Shut your windows and doors to ensure you make the best use of your gas heat and keep your energy bills low.</p></li>
                <li><p className="tip gas-tip">Check for Blockages: The warm air your natural gas heating system produces should be able to flow freely throughout your home. Make sure all necessary vents are open, and assess the layout of your home to ensure no bulky furniture or appliances are blocking the vents. If air cannot flow freely, the heating system will expend precious energy trying to warm a home that stubbornly refuses to warm up. But proper airflow reduces stress on your heating system and helps lower energy expenditures.</p></li>
            </ul>
          </div>
        </div>
        <div className="tip-outline">
          <div className="guide-section">
            <h2>Resources</h2>
            <ul>
              <li className="resource-outline">
                <a href="https://www.epa.gov/statelocalenergy/local-energy-efficiency-benefits-and-opportunities" target="_blank" rel="noreferrer" >
                  <div className="resource container">
                    <div className="flex-item"><h4>Local Energy Efficiency Benefits and Opportunities</h4>
                    <p>Using energy more efficiently is one of the fastest, most cost-effective ways to save money, reduce greenhouse gas emissions, create jobs, and meet growing energy demand....</p></div>
                    <div className="flex-item">
                      <img className="resource-image" src='/img/gas-site-1.png' alt="webpage preview"></img>
                    </div>
                  </div>
                  </a>
              </li>
              <li className="resource-outline">
                <a href="https://www.epa.gov/controlling-air-pollution-oil-and-natural-gas-industry" target="_blank" rel="noreferrer" >
                  <div className="resource container">
                    <div className="flex-item"><h4>Controlling Air Pollution from the Oil and Natural Gas Industry</h4>
                    <p>EPA’s Clean Air Act regulations for the oil and natural gas industry help combat climate change and reduce air pollution that harms public health...</p></div>
                    <div className="flex-item">
                      <img className="resource-image" src='/img/gas-site-2.png' alt="oil rig"></img>
                    </div>
                  </div>
                  </a>
              </li>
              <li className="resource-outline">
                <a href="https://www.epa.gov/natural-gas-star-program" target="_blank" rel="noreferrer" >
                  <div className="resource container">
                    <div className="flex-item"><h4>EPA’s Voluntary Methane Programs for the Oil and Natural Gas Industry</h4>
                    <p>Methane is a potent greenhouse gas 25 times more powerful than CO2 in trapping heat in the atmosphere over a 100-year period...</p></div>
                    <div className="flex-item">
                      <img className="resource-image" src='/img/gas-site-3.png' alt="website preview of events"></img>
                    </div>
                  </div>
                  </a>
              </li>
            </ul>
          </div>
          
        </div>
      </section>
    )
  }
}